export default {
  props: {
    data: {
      type: String,
      default: '',
    },
  },
};
